import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy link from plan purchase emails sent before HOP-798 (no locale, no such page).
export const Route = createFileRoute('/plans/$planId')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$locale/itinerary',
      params: { locale: 'en' },
      search: { tripId: params.planId },
      replace: true,
    });
  },
});
